module.exports = __webpack_public_path__ + "static/media/qrcode-buffl-app.f689177e.svg";